import './ButtonSecondary.css'
import './buttons.css';
const ButtonSecondary = ({onClick, children}) => {
    return(
        <div onClick={onClick} className='_custom_regular_button ButtonSecondary'>
            {children}
        </div>
    )
}
export default ButtonSecondary;